import { Button, DatePicker, Rate, Segmented, Table, Tag, Tooltip } from "antd"
import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useFetch } from "../../../hooks/useFetch/useFetch";
import { ExpandableText } from "../../atoms/ExpandableText";
import "../../../Styles/ReviewsAndFaQ.css"
import { CheckCircleOutlined, CheckCircleTwoTone, ClockCircleOutlined, ClockCircleTwoTone, LeftCircleFilled, LeftCircleTwoTone, RightCircleFilled, RightCircleTwoTone, ShopOutlined, StarFilled, TagOutlined } from "@ant-design/icons";
import googleLogo from "../../../assets/logo_google.png"
import { calculateDays } from "../../../common/utils/caculateDays";
import SelectPeriod from "../../molecules/forms/SelectedPeriod";
import moment from "moment";
import { ColorStar } from "../../atoms/ColorStar";
import 'moment/locale/es';
import ReviewSelected from "./ReviewSelected";

export const WidgetsReplyReviews = () => {

    let { id: key } = useParams();    
    const location = useLocation();    
    const placeId = new URLSearchParams(location.search).get('placeId');    
    
    const [title, setTitle] = useState(null);
    const [address, setAddress] = useState(null);
    const [reviewsList, setReviewsList] = useState(null);
    const [selectedReview, setSelectedReview] = useState(null);
    const [filterStatus, setFilterStatus] = useState('');//('&status=NOT_REPLIED');
    const [filterScore, setFilterScore] = useState('');
    const [filterReference, setFilterReference] = useState('&periodOpt=ALL');//('&periodOpt=LAST_30DAYS');
    const [requestParams, setRequestParams] = useState(filterStatus + filterScore + filterReference);
    const [pagination, setPagination] = useState({page:1});  
    const [isLoading, setIsLoading] = useState(false);
    const [refreshReviews, setRefreshReviews] = useState(true);

    let extraQueryParams = placeId ? '&placeId=' + placeId : '';    

    const onRangeChange = (range) => {
      setFilterReference('&periodOpt=' + range);
      handleResquestParam(filterStatus + filterScore + '&periodOpt=' + range);      
    };

    function handleResquestParam(requestParams) {
      setSelectedReview(null);
      setRequestParams(requestParams);
    }

    useFetch(
        `${process.env.REACT_APP_API}/widgets/reply-reviews/locations/${placeId}?key=${key}${extraQueryParams}${requestParams}` ,
        {},
        [refreshReviews],(data) => {                      
            setTitle(data.title);
            setAddress(data.address);
            setReviewsList(data.reviews);					
            setPagination(data.pagination);		
          }
    );

    function handleResquestParam(requestParams) {
        setSelectedReview(null);
        setRequestParams(requestParams);
      }

      const columns = [
        {
            title: '',
            key: 'reviewReplyComment',
            dataIndex: 'reviewReplyComment',
            align: 'center',
            width: '80px',
            render: (text, record) => (
                <>
                    {record.reviewReplyComment ? 
                        <div style={{color: 'green'}}><CheckCircleOutlined style={{fontSize:'20px'}}/></div>
                        :
                        <div style={{color: 'MediumVioletRed'}}><ClockCircleOutlined style={{fontSize:'20px'}}/></div>
                    }
                </>
            )
        },
        {
            title: 'Reseñas',
            key: 'text',
            dataIndex: 'text',
            width: '45%',           
            render: (text, record) => {
                const maxLength = 100;
                const truncatedText = !!record.comment.originalText && record.comment.originalText.length > maxLength ? record.comment.originalText.slice(0, maxLength) + '...' : record.comment.originalText;

                return (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                            <img src={record.reviewerProfilePhotoUrl} style={{ width: '30px' }} />
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <div>{record.reviewerDisplayName}</div>
                                <div style={{ fontSize: '10px', color: 'slategrey'}}>
                                    <Tooltip title={<>
                                                <div>Creada el {moment(record.createdTime).format('ll')}</div>
                                                {!moment(record.createdTime).isSame(moment(record.updateTime)) && <div>Actualizada el {moment(record.updateTime).format('ll')}</div>}
                                            </>}>
                                        <div style={{ fontSize: '10px', color: 'slategrey', textAlign:'right'}}>
                                            <div>Creada {moment(record.createdTime).fromNow()}</div>
                                            <div>{!moment(record.createdTime).isSame(moment(record.updateTime)) && <div>Actualizada {moment(record.updateTime).fromNow()}</div>}</div>
                                        </div>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        <p style={{ color: 'var(--grey)', fontSize: 12 }}>{truncatedText}</p>
                        {/*<small>{record.commentLabels?.map((label) => {
                            return <Tag color={'white'} style={{margin:'5px', border:`solid .5px ${LABEL_COLOR[label.score]}`}}>
                                        <Tooltip title={<><>{label.category}</> <span style={{background:'lightgrey', color:'black', padding:'1px 6px', margin:'2px 5px', borderRadius:'4px' }}>{label.score} <StarFilled/></span></>}><b style={{color:LABEL_COLOR[label.score]}}><TagOutlined/> {label.label}</b></Tooltip>
                                    </Tag>
                        })}</small> */}
                    </>
                );
            }
        },
        {
            title: 'Puntuación',
            key: 'starRating',
            dataIndex: 'starRating',
            align: 'center',
            render: (text, record) => (record.starRating &&
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ColorStar
                        style={{ fontSize: '18px' }}
                        value={Math.round(10 * record.starRating) / 10}/>
                </div>)
        }        
    ]

    const [selectedRowKey, setSelectedRowKey] = useState(null);

    const onSelectRow = ( record ) => {
        //console.log('onSelectRow() ' + record.name);
        handleReviewClick(record)
        const rowKey = record.name;
        setSelectedRowKey(rowKey);
    };

    const rowClassName = ({name}) => {
        return name === selectedRowKey ? 'selected-row' : '';
    };

    const handleReviewClick = ( record ) => {
        setSelectedReview(record)        
    };

    return (
        <div style={{background:'ghostwhite'}}>
            
            <h2 style={{margin:'0px', color:'darkslategrey'}}>{title}</h2>
            <p style={{margin:'0px', color:'grey'}}>{address}</p>            
            
            <div style={{ display: 'flex', justifyContent: 'space-between', borderRadius:'15px', margin:'25px 0px 0px 0px', alignItems:'center'}}>
              {reviewsList && 
                    <b style={{color: 'slategrey'}}>        
                        <Button type='link' onClick={()=>{setIsLoading(true); handleResquestParam('&page=' + (pagination.page - 1) + filterStatus + filterScore + filterReference)}} disabled={pagination.startDisabled}>    
                        <LeftCircleFilled/> 								
                        </Button>				
                        {pagination.from}-{pagination.to} de {pagination.total}
                        <Button type='link' onClick={()=>{setIsLoading(true); handleResquestParam('&page=' + (pagination.page + 1) + filterStatus + filterScore + filterReference)}} disabled={pagination.endDisabled}>    
                        <RightCircleFilled/>					
                        </Button>				
                    </b>
                }
            <div style={{display:'flex', alignItems:'center'}}>
            <Segmented
              value={filterStatus}
              style={{marginRight:30}}
              options={[
                { label: 'Todas', value: '' },
                { label: filterStatus === '&status=NOT_REPLIED' ? <b style={{color: 'royalblue'}}>Sin Respuesta</b>  : <>Sin Respuesta</>, value: '&status=NOT_REPLIED'},
                { label: filterStatus === '&status=REPLIED' ? <b style={{color: 'royalblue'}}>Respondidas</b>  : <>Respondidas</>, value: '&status=REPLIED' }
              ]}
              onChange={(value) => { setIsLoading(true); setFilterStatus(value); handleResquestParam(value + filterScore + filterReference) }}
            />
            <Segmented
              value={filterScore}
              style={{marginRight:30}}
              options={[
                { label: 'Todas', value: '' },
                { label: filterScore === '&score=POSITIVES' ? <b style={{color: 'royalblue'}}>Positivas</b>  : <>Positivas</>, value: '&score=POSITIVES' },
                { label: filterScore === '&score=NEGATIVES' ? <b style={{color: 'royalblue'}}>Negativas</b>  : <>Negativas</>, value: '&score=NEGATIVES' }
              ]}
              onChange={(value) => { setIsLoading(true); setFilterScore(value); handleResquestParam(filterStatus + value + filterReference) }}
            />          
            
            <SelectPeriod setSelectedType={onRangeChange} defaultValue='ALL'/>   
            </div>       	                    
        </div>
          <div style={{height: '80vh', marginTop: '30px', display: 'flex'}}>
            <div style={{width:'50%', padding:'10px'}}>
            <Table size='small'
                rowClassName={rowClassName}
                style={{background: 'GhostWhite'}}
                columns={columns}
                dataSource={reviewsList}
                rowKey="name"
                scroll={{ y: 600 }}
                pagination={false} 
                isLoading={isLoading}
                onRow={(record ) => ({
                    onClick: () => onSelectRow(record),
                    style: { cursor: 'pointer' },
                })} 
                /*onChange={(pagination: any, filters: any, sorter: any, extra: any) => {
                    setFilteredRows(extra?.currentDataSource?.length);
                    if(filters.text == null && filters.locality == null && filters.reviewReplyComment == null && filters.starRating == null){
                        setFilteredRows(reviewsData.length)
                    }
                }}*/
            />
            </div>            
            <div style={{width:'50%'}}>
            {selectedReview ?
                <ReviewSelected reviewId={selectedReview.name} keyId={key} onFinish={() => {setRefreshReviews(!refreshReviews)}}/>
                :
                <h2 style={{display:'flex', height:'100%', justifyContent:'center', alignItems:'center', color:'silver'}}>
                    Reseña sin seleccionar
                </h2>
            }
            </div>
          </div>
        </div>
        )        
    }

export const LABEL_COLOR = {
    "1": "Crimson",  
    "2": "Crimson",  
    "3": "Crimson",  
    "4": "DarkCyan", 
    "5": "DarkCyan"
}